import { getNumberFormat } from "../../utils/getNumberFormat.js";

const units = ["gram", "kilogram"] as const;

export function getWeightText(
	locale: Intl.LocalesArgument,
	weightInGrams: number,
	options: Omit<Intl.NumberFormatOptions, "style" | "unit"> = { unitDisplay: "narrow", maximumFractionDigits: 1 },
): string {
	const i = Math.min(Math.max(0, Math.floor(Math.log(weightInGrams) / Math.log(1000))), units.length - 1);
	const value = weightInGrams / 1000 ** i;
	const formatter = getNumberFormat(locale, { style: "unit", unit: units[i], ...options });
	return formatter.format(value);
}
